// schema
import * as ISchema from "#webapp/src/__schema__";

// libraries
import * as React from "react";
import { createFragmentContainer, RelayProp } from "react-relay";

// state and mutations
import { asanaWrapperFragments } from "./AsanaWrapper.gql";

export interface AsanaTaskProps {
  viewer: ISchema.IViewer;
  relay: RelayProp;
  children: React.ReactNode;
}

const AsanaWrapperComponent = ({ children, viewer, relay }: AsanaTaskProps) => {
  if (!viewer) {
    return null;
  }

  const childrenWithProps = React.Children.map(children, (child) => {
    // checking isValidElement ensures safety and avoids a typescript error
    if (React.isValidElement<{ viewer: ISchema.IViewer; relay: RelayProp }>(child)) {
      return React.cloneElement(child, { viewer, relay });
    }
    return child;
  });

  return <div>{childrenWithProps}</div>;
};

///////////
// Relay //
///////////

export const AsanaWrapper = createFragmentContainer<AsanaTaskProps>(
  AsanaWrapperComponent,
  asanaWrapperFragments,
);
